export default __webpack_public_path__ + "static/media/eye.77f2e2eb.svg";